import { Button } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BlueCargoLogo from 'components/BlueCargoLogo';
import { usePermissions } from 'utils/permissions';
import { Routes } from 'constants/pages';
import { FeatureFlag, useFeatureFlag } from 'utils/permissions/feature-flags';
import { getNavigationItems, MenuItemType } from '../../utils/menus';
import UserProfileItem from '../../UserProfileItem';
import { NAV_HEIGHT } from '../../utils/config';
import { User } from '../../../../types/User';

import { MenuItem } from './MenuItem';
import { MenuDropdown } from './MenuDropdown';
import { UpgradeButton } from './UpgradeButton';

interface Props {
  user: User | null;
}

export const DesktopNav: React.FC<Props> = ({ user }) => {
  const location = useLocation();
  const permissions = usePermissions();
  const items = getNavigationItems(permissions, user);
  const navigate = useNavigate();
  const showRoiCta = useFeatureFlag(FeatureFlag.DisputeDemo);

  const mappedItems = items.map((item: MenuItemType): React.ReactNode => {
    switch (item.type) {
      case 'flat':
        return <MenuItem page={item.page} user={user} key={item.page.title} />;
      case 'nested':
        return <MenuDropdown dropdown={item} location={location} key={item.title} />;
      default:
        return null;
    }
  });

  return (
    <div
      className="w-full bg-blue-900 shadow-md flex items-center px-4 space-x-4 justify-between overflow-hidden"
      style={{ height: NAV_HEIGHT }}
    >
      <div className="flex items-center space-x-2 grow">
        <div className="flex items-center space-x-10">
          <BlueCargoLogo />
          {showRoiCta && (
            <Button
              className="!bg-orange-900 hover:!bg-orange-800 font-medium !py-1.5 !px-2.5 text-white"
              onClick={() => navigate(Routes.PerDiemFighterCalculator)}
            >
              <h4>ROI Calculator</h4>
            </Button>
          )}
        </div>
        <div className="flex items-center justify-center grow">
          <div className="flex items-center space-x-12">
            <div className="flex space-x-2 items-center">{mappedItems}</div>
          </div>
        </div>
      </div>
      <div className="flex space-x-8 items-center">
        {/* upgrade button */}
        <UpgradeButton user={user} />
        {/* user profile */}
        <UserProfileItem />
      </div>
    </div>
  );
};
DesktopNav.displayName = 'DesktopNav';
